import { render, staticRenderFns } from "./CustomerJourney.vue?vue&type=template&id=0c37b147&scoped=true&"
import script from "./CustomerJourney.vue?vue&type=script&lang=js&"
export * from "./CustomerJourney.vue?vue&type=script&lang=js&"
import style0 from "./CustomerJourney.vue?vue&type=style&index=0&id=0c37b147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37b147",
  null
  
)

export default component.exports